<i18n>
{
  "en": {
      "ecpay_text": "Credit Card (in TWD)",
      "ecpay_text_remark": "*The payment method is only available in Taiwan.<br/>*You can use Debit card or Prepaid card as well.",
      "paypal_text_USD": "PayPal (in USD)",
      "paypal_text_JPY": "PayPal (in JPY)",
      "stripe_text_USD": "Credit Card (in USD)",
      "stripe_text_TWD": "Credit Card (in TWD)",
      "stripe_text_JPY": "Credit Card (in JPY)",
      "stripe_text_KRW": "Credit Card (in KRW)",
      "stripe_text_remark": "*Debit card or Prepaid card is accepted as well.",
      "plan_code": "Business code",
      "coupon_code": "Coupon Code",
      "bonus_text_field": "Referral code",
      "bonus_info": "Enter the referral code and get 5 days bonuses for you and your friend (the referee only gets one bonus, while the referrer gets as many as you referred)",
      "bonus_already_used": "This account already got a referral bonus",
      "bonus_not_exist": "The referral code does not exist",
      "bonus_self_referral_not_allowed": "You cannot refer yourself",
      "bonus_valid": "Referral code verified. Please select the payment method",
      "apply": "apply",
      "plan_not_found": "Business code not found, please check if typo.",
      "plan_out_of_stock": "The business code has run out.",
      "plan_expired": "The business code has expired.",
      "subscription_plan": "Subscription plan",
      "billing_monthly": "Monthly",
      "billing_yearly": "Yearly",
      "billing_yearly_save": "Save 20%",
      "tier_standard": "Standard",
      "tier_pro": "Pro",
      "tier_most_popular": "Most Popular",
      "tsum_pro_benefits_title": "Includes everything in Standard, plus:",
      "tsum_pro_benefit_1": "Dedicated dual premium hardware for ultra-smooth auto-play and higher efficiency",
      "tsum_pro_benefit_2": "Priority scheduling after major game updates (subject to availability)",
      "tsum_pro_benefit_3": "Up to 15 minutes of uninterrupted live streaming (Standard: 100 seconds; depends on network)",
      "tsum": "LINE: Disney Tsum Tsum",
      "cookieKingdom": "Cookie Run: Kingdom",
      "mlb9i": "MLB 9 Innings 26",
      "payment_desc": "Only {currency} {price} per {frequency} days",
      "payment_desc_equivalent": "Only {currency} {price} per {frequency} days on average",
      "billed_every": "Billed {currency} {price} every {frequency} days",
      "tsum_desc": " ",
      "cookieKingdom_desc": " ",
      "mlb9i_desc": " "
  },
  "zhHant": {
      "ecpay_text": "信用卡 (台幣計價)",
      "ecpay_text_remark": "＊此付款方式僅適用於台灣<br/>＊扣帳卡(Debit card)或預付卡(Prepaid card)亦可用此方式結帳",
      "paypal_text_USD": "PayPal (美金計價)",
      "paypal_text_JPY": "PayPal (日元計價)",
      "stripe_text_USD": "信用卡 (美金計價)",
      "stripe_text_TWD": "信用卡 (台幣計價)",
      "stripe_text_JPY": "信用卡 (日元計價)",
      "stripe_text_KRW": "信用卡 (韓元計價)",
      "stripe_text_remark": "＊扣帳卡(Debit card)或預付卡(Prepaid card)亦可用此方式結帳",
      "plan_code": "企業代碼",
      "coupon_code": "兌換代碼",
      "bonus_text_field": "推薦序號",
      "bonus_info": "輸入推薦序號，你和朋友一起額外獲得5天獎勵。（被推薦人一個帳號限定一次，推薦人不限次數）",
      "bonus_already_used": "此帳號已經領取獎勵了",
      "bonus_not_exist": "推薦者序號不存在",
      "bonus_self_referral_not_allowed": "不允許自我推薦",
      "bonus_valid": "推薦序號有效，接著請選擇您的付款方式",
      "apply": "送出",
      "plan_not_found": "企業代碼不存在，請檢查是否輸入錯誤",
      "plan_out_of_stock": "企業代碼已全數被使用完畢",
      "plan_expired": "企業代碼已過期",
      "subscription_plan": "訂閱方案",
      "billing_monthly": "月繳",
      "billing_yearly": "年繳",
      "billing_yearly_save": "省 20%",
      "tier_standard": "標準版",
      "tier_pro": "專業版",
      "tier_most_popular": "最受歡迎",
      "tsum_pro_benefits_title": "包含標準版所有功能，另加：",
      "tsum_pro_benefit_1": "獨立雙倍高級硬體，自動玩遊戲超流暢效率飆升",
      "tsum_pro_benefit_2": "遊戲大更新後優先排程（以實際情況為準）",
      "tsum_pro_benefit_3": "直播遊戲狀態 15 分鐘不中斷（標準版 100 秒，視網路而定）",
      "tsum": "LINE: Disney Tsum Tsum",
      "cookieKingdom": "薑餅人王國",
      "mlb9i": "MLB：9局職棒 26",
      "payment_desc": "每{frequency}天只要{currency} {price}",
      "payment_desc_equivalent": "平均每{frequency}天只要{currency} {price}",
      "billed_every": "每{frequency}天扣款 {currency} {price}",
      "tsum_desc": " ",
      "cookieKingdom_desc": " ",
      "mlb9i_desc": " "
  },
  "ja": {
      "ecpay_text": "クレジットカード（台湾ドル）",
      "ecpay_text_remark": "※この支払い方法は台湾でのみご利用いただけます。<br/>※デビットカード・プリペイドカードでもお支払いいただけます。",
      "paypal_text_USD": "PayPal（米ドル）",
      "paypal_text_JPY": "PayPal（日本円）",
      "stripe_text_USD": "クレジットカード（米ドル）",
      "stripe_text_TWD": "クレジットカード（台湾ドル）",
      "stripe_text_JPY": "クレジットカード（日本円）",
      "stripe_text_KRW": "クレジットカード（韓国ウォン）",
      "stripe_text_remark": "※デビットカード・プリペイドカードでもお支払いいただけます。",
      "plan_code": "法人コード",
      "coupon_code": "クーポンコード",
      "bonus_text_field": "友達紹介コード",
      "bonus_info": "友達紹介コードを入力すると、お客様とお友達それぞれのライセンスが5日間延長されます。（コードをご利用いただけるのは、お友達1アカウントにつき1回限りです。お客様の紹介コードをご利用いただける人数に制限はありません。）",
      "bonus_already_used": "このアカウントは既に特典を受け取っています。",
      "bonus_not_exist": "この友達紹介コードは存在しません。ご確認のうえ、もう一度ご入力ください。",
      "bonus_self_referral_not_allowed": "ご自身の紹介コードはご利用いただけません。",
      "bonus_valid": "有効なコードです。お支払い方法をお選びください。",
      "apply": "送信",
      "plan_not_found": "この法人コードは存在しません。ご確認のうえ、もう一度ご入力ください。",
      "plan_out_of_stock": "この法人コードは、ご利用可能な上限に達しています。",
      "plan_expired": "この法人コードは有効期限が切れています。",
      "subscription_plan": "サブスクリプションプラン",
      "billing_monthly": "月額",
      "billing_yearly": "年額",
      "billing_yearly_save": "20%お得",
      "tier_standard": "スタンダード",
      "tier_pro": "プロ",
      "tier_most_popular": "人気No.1",
      "tsum_pro_benefits_title": "スタンダードプランの全機能に加えて",
      "tsum_pro_benefit_1": "性能2倍の専用ロボットで、自動プレイがさらにスムーズ・高速に",
      "tsum_pro_benefit_2": "ゲームの大型アップデート後は、優先的に自動プレイを再開（状況により異なります）",
      "tsum_pro_benefit_3": "ゲーム画面のライブ配信が15分間途切れず利用可能（スタンダードは100秒。通信環境により異なります）",
      "tsum": "LINE：ディズニー ツムツム",
      "cookieKingdom": "クッキーラン：キングダム",
      "mlb9i": "MLB：9イニングス26",
      "payment_desc": "{frequency}日ごとに {currency} {price}",
      "payment_desc_equivalent": "実質{frequency}日あたり {currency} {price}",
      "billed_every": "{frequency}日ごとに {currency} {price} を請求",
      "tsum_desc": " ",
      "cookieKingdom_desc": " ",
      "mlb9i_desc": " "
  },
  "ko": {
      "ecpay_text": "신용카드 결제 (신 대만 달러)",
      "ecpay_text_remark": "*대만에서만 사용 가능.<br/>*신용카드와 체크카드 방식으로 결제 가능합니다.",
      "paypal_text_USD": "페이팔 결제 (달러)",
      "paypal_text_JPY": "페이팔 결제 (엔화)",
      "stripe_text_USD": "신용카드 결제 (달러)",
      "stripe_text_TWD": "신용카드 결제 (신 대만 달러)",
      "stripe_text_JPY": "신용카드 결제 (엔화)",
      "stripe_text_KRW": "페이팔 결제 (원)",
      "stripe_text_remark": "신용카드와 체크카드 방식으로 결제 가능합니다.",
      "plan_code": "엔터프라이즈 코드를 입력해주세요.",
      "coupon_code": "쿠폰 코드를 입력해주세요.",
      "bonus_text_field": "공유받은 추천 코드를 입력해주세요.",
      "bonus_info": "추천 코드를 입력하면 친구와 함께 라이센스 5일을 보너스로 드립니다. (추천자는 1회 한정, 추천인은 횟수 제한 없습니다.)",
      "bonus_already_used": "이 계정은 이미 보너스를 지급받았습니다.",
      "bonus_not_exist": "존재하지 않는 추천 코드입니다.",
      "bonus_self_referral_not_allowed": "자기 자신의 추천 코드를 입력 할 수 없습니다.",
      "bonus_valid": "추천 코드가 확인되었습니다. 결제 방식을 선택해주세요.",
      "apply": "등록하기",
      "plan_not_found": "엔터프라이즈 코드가 존재하지 않습니다.",
      "plan_out_of_stock": "이미 만료된 엔터프라이즈 코드입니다.",
      "plan_expired": "엔터프라이즈 코드가 만료되었습니다.",
      "subscription_plan": "라이센스 정기 구독합니다.",
      "billing_monthly": "월 구독",
      "billing_yearly": "연 구독",
      "billing_yearly_save": "20% 절약",
      "tier_standard": "일반버전",
      "tier_pro": "프로버전",
      "tier_most_popular": "가장 인기",
      "tsum_pro_benefits_title": "일반버전의 모든 기능에 더해:",
      "tsum_pro_benefit_1": "독립형 2배 고급 하드웨어로 더욱 부드러운 자동 플레이와 효율 향상",
      "tsum_pro_benefit_2": "게임 대규모 업데이트 후 우선 스케줄링 (실제 상황에 따라 다름)",
      "tsum_pro_benefit_3": "라이브 스트리밍 최대 15분 무중단 (일반버전 100초, 네트워크 환경에 따라 다름)",
      "tsum": "라인 디즈니 썸썸",
      "cookieKingdom": "쿠키런: 킹덤",
      "mlb9i": "MLB 9이닝스 26",
      "payment_desc": "{frequency}일 마다{currency} {price}",
      "payment_desc_equivalent": "{frequency}일 기준 {currency} {price}",
      "billed_every": "{frequency}일마다 {currency} {price} 결제",
      "tsum_desc": " ",
      "cookieKingdom_desc": " ",
      "mlb9i_desc": " "
  }
}
</i18n>
<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <!-- Main session -->
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
        <div class="header-logo">
          <GameLogo :imageUrl="headerImgURL" />
          <br />
          {{ $t(supportGame) }}
        </div>
      </v-flex>
      <v-flex v-if="loading" xs12 text-xs-center>
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-flex>
      <v-flex v-if="!loading && showBillingToggle" xs12 sm8 offset-sm2 md6 offset-md3 class="text-xs-center">
        <v-btn-toggle v-model="billingCycle" mandatory class="billing-toggle">
          <v-btn flat value="monthly" class="text-none">{{ $t('billing_monthly') }}</v-btn>
          <v-btn flat value="yearly" class="text-none">
            {{ $t('billing_yearly') }}
            <v-chip small color="green" text-color="white" class="ml-2">{{ $t('billing_yearly_save') }}</v-chip>
          </v-btn>
        </v-btn-toggle>
      </v-flex>
      <v-flex v-for="group in planGroups" v-bind:key="group.tier" xs12 sm8 offset-sm2 md6 offset-md3>
        <v-hover>
          <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto">
            <v-card-title class="white--text layout column align-center py-3"
              :class="group.tier === 'pro' ? 'deep-purple' : 'orange'">
              <v-layout row align-center justify-center>
                <v-flex shrink>
                  <v-chip small color="white" :text-color="group.tier === 'pro' ? 'deep-purple' : 'orange'">
                    {{ group.tier === 'pro' ? $t('tier_pro') : $t('tier_standard') }}
                  </v-chip>
                </v-flex>
                <v-flex v-if="group.tier === 'standard'" shrink>
                  <v-chip small color="green" text-color="white">
                    <v-icon small left>mdi-thumb-up</v-icon>
                    {{ $t('tier_most_popular') }}
                  </v-chip>
                </v-flex>
              </v-layout>
              <span class="subheading pt-2 text-xs-center">
                {{ $t(supportGame) }} {{ $t('subscription_plan') }}
              </span>
            </v-card-title>
            <v-card-text v-if="group.tier === 'pro' && proBenefitKeys.length > 0" class="pb-0">
              <v-subheader class="px-0">{{ $t(proBenefitsTitleKey) }}</v-subheader>
              <v-list dense three-line class="pt-0">
                <v-list-tile v-for="benefitKey in proBenefitKeys" v-bind:key="benefitKey">
                  <v-list-tile-action>
                    <v-icon color="deep-purple">mdi-check</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-sub-title>{{ $t(benefitKey) }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
            <v-divider v-if="group.tier === 'pro' && proBenefitKeys.length > 0"></v-divider>
            <template v-for="(plan, index) in group.plans">
              <v-divider v-if="index > 0" v-bind:key="'divider-' + plan.planId"></v-divider>
              <v-card-text v-bind:key="plan.planId" class="pt-3 pb-3">
                <div v-if="plan.description" class="caption grey--text text--darken-3 mb-2">{{ plan.description }}</div>
                <div class="subheading font-weight-bold" :class="isSinglePeriod(plan) ? 'mb-3' : 'mb-1'">
                  {{
                    $t(isSinglePeriod(plan) ? 'payment_desc' : 'payment_desc_equivalent', {
                      currency: plan.currency,
                      price: displayPrice(plan),
                      frequency: displayFrequency(plan),
                    })
                  }}
                </div>
                <div v-if="!isSinglePeriod(plan)" class="caption black--text mb-3">
                  {{
                    $t('billed_every', {
                      currency: plan.currency,
                      price: plan.price,
                      frequency: plan.frequency,
                    })
                  }}
                </div>
                <div v-if="plan.vendor === 'ECPay'" class="caption grey--text mb-2" v-html="$t('ecpay_text_remark')">
                </div>
                <div v-if="plan.vendor === 'Stripe'" class="caption grey--text mb-2">{{ $t('stripe_text_remark') }}
                </div>
                <v-btn v-if="plan.vendor === 'ECPay'" block color="green" dark @click="buy(plan.planId)"
                  class="text-none font-italic font-weight-bold">
                  <v-icon>mdi-credit-card-outline</v-icon>
                  {{ $t('ecpay_text') }}
                </v-btn>
                <v-btn v-if="plan.vendor === 'PayPal'" block color="#179bd7" dark @click="buy(plan.planId)"
                  class="text-none font-italic font-weight-bold">
                  <v-icon>mdi-paypal</v-icon>
                  {{ $t('paypal_text_' + plan.currency) }}
                </v-btn>
                <v-btn v-if="plan.vendor === 'Stripe'" block color="#6772e5" dark @click="buy(plan.planId)"
                  class="text-none font-italic font-weight-bold">
                  <v-icon>mdi-credit-card-outline</v-icon>
                  {{ $t('stripe_text_' + plan.currency) }}
                </v-btn>
              </v-card-text>
            </template>
          </v-card>
        </v-hover>
      </v-flex>
      <!-- QA session -->
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
        <QA></QA>
      </v-flex>
      <!-- Referral session -->
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3 v-if="newPlanEnabled === false">
        <v-hover>
          <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto">
            <v-card-text>
              {{ $t('bonus_info') }}
              <div>
                <span class="grey--text"></span>
                <v-text-field v-model="referrerBonusId" :label="$t('bonus_text_field')" :error-messages="referrerError"
                  :success-messages="referrerSuccess"
                  :disabled="referrerSuccess !== undefined && referrerSuccess !== ''" required></v-text-field>
              </div>
            </v-card-text>
            <v-card-actions v-if="referrerSuccess === undefined || referrerSuccess === ''">
              <v-btn block color="primary" outline :loading="referrerChecking" :disabled="referrerChecking"
                @click="checkBonusReferrerAvailable">{{ $t('apply') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-flex>
      <!-- Group code session -->
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3 v-if="newPlanEnabled === false">
        <v-hover>
          <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto">
            <span class="grey--text"></span>
            <v-card-text>
              <v-text-field v-model="planCode" :label="$t('plan_code')" required></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn block color="primary" outline @click="getReferralPlan" :loading="planChecking"
                :disabled="planChecking || planCode === ''">{{ $t('apply') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-flex>
      <!-- Coupon code session -->
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
        <v-hover>
          <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto">
            <span class="grey--text"></span>
            <v-card-text>
              <v-text-field v-model="couponCode" :label="$t('coupon_code')" required></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn block color="primary" outline @click="exchangeCoupon" :loading="exchanging"
                :disabled="exchanging || couponCode === ''">{{ $t('apply') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/functions';
import assetMisc from '../assets/misc';
import QA from '../components/QA';
import GameLogo from '@/components/ui/GameLogo';

const PRO_BENEFIT_KEYS_BY_GAME = {
  tsum: ['tsum_pro_benefit_1', 'tsum_pro_benefit_2', 'tsum_pro_benefit_3'],
};

export default {
  name: 'plan',
  components: { QA, GameLogo },
  data() {
    return {
      headerImgURL: assetMisc.robotmonLogoUrl,
      supportGame: '',
      loading: true,
      referrerChecking: false,
      referrerBonusId: '',
      referrerError: '',
      referrerSuccess: '',
      planChecking: false,
      planCode: '',
      plans: [],
      billingCycle: 'monthly',
      newPlanEnabled: false,
      exchanging: false,
      couponCode: '',
    };
  },
  computed: {
    proBenefitKeys() {
      return PRO_BENEFIT_KEYS_BY_GAME[this.supportGame] || [];
    },
    proBenefitsTitleKey() {
      if (this.proBenefitKeys.length === 0) {
        return '';
      }
      return `${this.supportGame}_pro_benefits_title`;
    },
    showBillingToggle() {
      const hasMonthly = this.plans.some(plan => this.isSinglePeriod(plan));
      const hasYearly = this.plans.some(plan => !this.isSinglePeriod(plan));
      return hasMonthly && hasYearly;
    },
    planGroups() {
      const tiers = ['standard', 'pro'];
      return tiers
        .map(tier => ({
          tier,
          plans: this.sortPlans(
            this.plans.filter(plan => this.getPlanTier(plan) === tier && this.matchesBillingCycle(plan)),
          ),
        }))
        .filter(group => group.plans.length > 0);
    },
  },
  async mounted() {
    this.supportGame = this.$route.params.supportGame;
    console.log('Plan:', this.supportGame);
    this.loading = true;
    await this.getPlans();
    this.loading = false;

    switch (this.supportGame) {
      case 'tsum':
        this.headerImgURL = assetMisc.tsumLogoUrl;
        break;
      case 'cookieKingdom':
        this.headerImgURL = assetMisc.cookieKingdomLogoUrl;
        break;
      case 'mlb9i':
        this.headerImgURL = assetMisc.mlb9iLogoUrl;
        break;
      default:
        this.headerImgURL = assetMisc.tsumLogoUrl;
    }
  },
  methods: {
    getPlanTier(plan) {
      return plan.licenseTier || 'standard';
    },
    isSinglePeriod(plan) {
      return Number(plan.frequency) === 30;
    },
    matchesBillingCycle(plan) {
      if (!this.showBillingToggle) {
        return true;
      }
      return this.billingCycle === 'yearly' ? !this.isSinglePeriod(plan) : this.isSinglePeriod(plan);
    },
    displayFrequency(plan) {
      return this.isSinglePeriod(plan) ? plan.frequency : 30;
    },
    displayPrice(plan) {
      if (this.isSinglePeriod(plan)) {
        return plan.price;
      }
      const price = Number(plan.price);
      const frequency = Number(plan.frequency);
      const per30Days = (price / frequency) * 30;
      const decimals = Number.isInteger(price) ? 0 : 2;
      const factor = 10 ** decimals;
      const rounded = Math.round(per30Days * factor) / factor;
      return decimals === 0 ? rounded : rounded.toFixed(decimals);
    },
    sortPlans(plans) {
      let sorted = [...plans];
      sorted = this.upUSDPlansPriority(sorted);
      sorted = this.downPayPalPlansPriority(sorted);
      return sorted;
    },
    async exchangeCoupon() {
      const exchangeCouponFunc = firebase.functions().httpsCallable('XRobotmonGroup-xExchangeCoupon');
      this.exchanging = true;
      this.couponCode = this.couponCode.trim();
      try {
        await exchangeCouponFunc({
          couponId: this.couponCode,
        });
        this.$router.push({ name: 'home' });
      } catch (e) {
        alert(e.message);
      }
      this.exchanging = false;
    },
    buy(planId) {
      const plan = this.plans.find(v => v.planId === planId);
      if (plan === undefined) {
        alert('Plan is undefined');
        return;
      }
      this.$router.push({
        name: 'purchase',
        query: {
          type: 'subscription',
          planId: planId,
          vendor: plan.vendor,
          vendorPlanId: plan.vendorPlanId,
          referrerId: this.referrerSuccess ? this.referrerBonusId : '',
        },
      });
    },
    async checkBonusReferrerAvailable() {
      if (this.referrerBonusId === '') {
        this.referrerError = '';
        this.referrerSuccess = '';
        return;
      }
      const xCheckBonusReferrerAvailable = firebase
        .functions()
        .httpsCallable('XRobotmonGroup-xCheckBonusReferrerAvailable');
      this.referrerChecking = true;
      try {
        const result = await xCheckBonusReferrerAvailable({
          referrerId: this.referrerBonusId,
          supportGame: this.supportGame,
        });
        const data = result.data;
        if (data.success) {
          this.referrerError = '';
          this.referrerSuccess = this.$t('bonus_valid');
          return;
        }
        if (data.error === 'AlreadyUsed') {
          this.referrerError = this.$t('bonus_already_used');
        } else if (data.error === 'LicenseNotExists') {
          this.referrerError = this.$t('bonus_not_exist');
        } else if (data.error === 'SelfReferral') {
          this.referrerError = this.$t('bonus_self_referral_not_allowed');
        } else {
          alert(data.error);
          this.$router.push({ name: 'home' });
        }
        this.referrerBonusId = '';
      } catch (e) {
        this.referrerError = e.message;
      }
      this.referrerChecking = false;
      return;
    },
    downPayPalPlansPriority(plans) {
      for (let i = plans.length - 1; i >= 0; i--) {
        if (plans[i].vendor === 'PayPal') {
          const plan = plans.splice(i, 1)[0];
          plans.push(plan);
        }
      }
      return plans;
    },
    upUSDPlansPriority(plans) {
      for (let i = 0; i < plans.length; i++) {
        if (plans[i].currency === 'USD') {
          const plan = plans.splice(i, 1)[0];
          plans.unshift(plan);
        }
      }
      return plans;
    },
    async getPlans() {
      const xGetPlans = firebase.functions().httpsCallable('XRobotmonGroup-xGetPlans');
      const result = await xGetPlans({ supportGame: this.supportGame });
      console.log(result.data.plans);
      this.$set(this, 'plans', result.data.plans);
    },
    getReferralPlan() {
      const xGetPlanByCode = firebase.functions().httpsCallable('XRobotmonGroup-xGetPlanByCode');
      this.planChecking = true;
      xGetPlanByCode({ planCode: this.planCode }).then(result => {
        this.planChecking = false;
        if (!result.data.plan) {
          alert(this.$t('plan_not_found'));
          return;
        }
        const newPlan = result.data.plan;
        // Check if plan has expired
        const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
        if (newPlan.expireTime !== 0 && newPlan.expireTime <= currentTime) {
          alert(this.$t('plan_expired'));
          return;
        }
        if (newPlan.quota < 1) {
          alert(this.$t('plan_out_of_stock'));
          return;
        }
        // check if planId already exists
        for (const plan of this.plans) {
          if (plan.planId === newPlan.planId) {
            return;
          }
        }
        this.newPlanEnabled = true;
        this.billingCycle = this.isSinglePeriod(newPlan) ? 'monthly' : 'yearly';
        this.plans.push(newPlan);
      });
    },
  },
};
</script>

<style scoped>
.header-logo {
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.header-logo .v-card__text {
  text-align: center;
}

.billing-toggle >>> .v-btn {
  text-transform: none;
  opacity: 1;
}

.billing-toggle >>> .v-btn--active {
  background-color: #ff9800 !important;
  color: #fff !important;
}

.billing-toggle >>> .v-btn--active::before {
  opacity: 0;
}
</style>
